// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"841":"e07b2301820ec224297c","865":"e07b2301820ec224297c","7587":"e07b2301820ec224297c","7906":"dc378dd8e4f14838e17b","8736":"50172c5d9c05b84be601"}[chunkId] + ".css";
};